import classNames from 'classnames';
import * as React from 'react';

import { AppFormField, AppFormFieldProps } from './appFormField';

export class AppTextField extends AppFormField {
  protected renderInput(field: AppFormFieldProps): JSX.Element {
    return (
      <input
        readOnly={this.props.readonly}
        {...field.input}
        className={classNames({ invalid: this.isFieldInvalid(field) }, 'text-input', 'form-control')}
        placeholder={this.props.placeholder}
        type={this.props.type || 'text'}
        disabled={this.props.disabled}
      />
    );
  }
}
